const isAdminUser = (user: { admin: boolean }): boolean => user && user.admin
export default isAdminUser
